import { apiClient } from "api";

const API_URL = "/VoiceFiles";

export const loadVoiceFile = async (vfId: number): Promise<Blob> => {
    const response = await apiClient.get<Blob>(`${API_URL}/audio?vfId=${vfId}`, {
        responseType: 'blob', 
    });
    return response.data; 
};